export default {
// 'necessary': {
//     name: "necessary",
//     disabled: true,
//     value: true,
//     title: "Necessary Cookies",
//     description: "Necessary cookies help make a website usable by enabling basic\
//     functions like page navigation and access to secure areas of the website. The website cannot\
//     function properly without these cookies.",
//     function: function() {},
//     cookies: [
//         {
//             name : "CookieConsent",
//             provider : "cookieconsent.extension",
//             purpose : "Stores the user's cookie consent state for the current domain",
//             expiry : "1 year",
//             type : "HTTP",
//         },
//     ]
// },
// analytics: {
//     name: "analytics",
//     value: true,
//     title: "Analytics Cookies",
//     function: function() {},
//     description: "Analytic cookies help website owners to understand how visitors\
//     interact with websites by collecting and reporting information anonymously.",
//     cookies: [
//         {
//             name : "_ga",
//             provider : "Google",
//             purpose : "Registers a unique ID that is used to generate statistical data on how the visitor uses the website.",
//             expiry : "2 years",
//             type : "HTTP",
//         },
//         {
//             name : "_gat",
//             provider : "Google",
//             purpose : "Used by Google Analytics to throttle request rate",
//             expiry : "1 day",
//             type : "HTTP",
//         },
//         {
//             name : "_gid",
//             provider : "Google",
//             purpose : "Registers a unique ID that is used to generate statistical data on how the visitor uses the website.",
//             expiry : "1 day",
//             type : "HTTP",
//         }
//     ]
// }
};
/*
    Type de cookie possible:
    'unclassified': {
        name: "unclassified",
        hideToggle: true,
        value: true,
        disabled: true,
        function: function() {},
        title: "Cookies",
        description: "Description",
        cookies: [
            {
                name : "Name",
                provider : "Provider",
                purpose : "Description",
                expiry : "Expiration",
                type : "HTTP",
            },
        ]
    }
*/ 
